export default __webpack_public_path__ + "static/media/18.11eebe3f.jpg";